import { Component, Input } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { InputControlComponent } from '../../../controls/standard/input-control/input-control.component';
import { createPasswordValidator } from '../../../../validators/password.validator';

@Component({
	selector: 'app-password-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, InputControlComponent],
	templateUrl: './password-field.component.html',
	styleUrls: ['./password-field.component.scss'],
})
export class PasswordFieldComponent extends BaseFieldComponent {
	@Input('autocomplete') public autocomplete: string = 'on';

	/**
	 * All validators required for this field.
	 * @date 7/15/2022 - 12:14:13 PM
	 *
	 * @public
	 * @static
	 * @override
	 * @type {ValidatorFn[]}
	 */
	public static override validators: ValidatorFn[] = [createPasswordValidator()];
}
